import React from 'react';
import RepeatableContent from './repeatable-content';

export const EventCardHeader = props => <div className="card-header__event mb-2">{props.text}</div>;

export const EventCard = ({ cardClass, children }) => <div className={`card ${cardClass || ''}`}>{children}</div>;

export const EventCardWrapper = (props) => {
  const { contentToMap, children } = props;
  return (<div className="col-12 px-sm-0">
    {contentToMap && <RepeatableContent {...props} />}
    {children}
  </div>);
};
